import { render, staticRenderFns } from "./organization-control-test-form.vue?vue&type=template&id=cd9f1418&"
import script from "./organization-control-test-form.vue?vue&type=script&lang=js&"
export * from "./organization-control-test-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports